import { styled } from 'styled-components';
import { breakpoint, spacing } from 'styles/helpers';


export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;

  ${breakpoint.mobile} {
    padding: ${spacing['4xl']} ${spacing.l};
  }
`;

export const MainContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${spacing.l};
  max-width: 500px;
  text-align: center;
`;

export const Heading = styled.h1`
  color: ${({ theme }) => theme.colors.textModal};
  font-family: ${({ theme }) => theme.fontFamily.medium};
`;

export const Subheading = styled.p`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;